import { render } from "./BoxLabel.vue?vue&type=template&id=740c77be"
import script from "./BoxLabel.vue?vue&type=script&lang=js"
export * from "./BoxLabel.vue?vue&type=script&lang=js"

import "./BoxLabel.vue?vue&type=style&index=0&id=740c77be&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__